<template>
  <div class="token-services-data bg--color-02">
    <div class="token-services-data__numbers container-new">
      <a
        v-for="(service, index) in services"
        :key="index"
        class="token-services-data__number-item bg--color-01"
        :href="!service.isSoon && service.link ? service.link : '#'"
        :target="!service.isSoon && service.link ? '_blank' : '_self'"
        :class="!service.isSoon ? `token-services-data__${service.classForHover}` : ''"
      >
        <img :src="service.image" :alt="service.service">

        <div class="token-services-data__number-item-data">
          <div
            class="token-services-data__number-item-rate txt txt--26px txt--44px--l txt--height-32px txt--height-58px--l txt--color-04 txt--bold"
          >
            <span>***</span>

            <div
              v-if="service.isSoon"
              class="token-services-data__stat-item-soon bg--color-10 txt txt--color-04 txt--10px txt--14px--m txt--height-14px txt--height-24px--m txt--weight-400 mt-4--m"
            >
              {{ $t('common.promo.comingSoon') }}
            </div>
          </div>
          <span
            class="txt txt--16px txt--26px--l txt--height-24px txt--height-34px--l txt--color-04"
          >
            {{ $t('welcome.topSection.onService') }} {{ service.service }}
          </span>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TokenServicesData',
  computed: {
    services () {
      return [
        {
          // rank: this.cmcExchangeRank,
          isSoon: false,
          service: 'CoinMarketCap',
          image: require('@/assets/icons/welcome/cmc.svg'),
          link: 'https://coinmarketcap.com/currencies/patex/',
          classForHover: 'hovered-cmc'
        },
        {
          // rank: this.cgExchangeRank,
          isSoon: true,
          service: 'CoinGecko',
          image: require('@/assets/icons/welcome/coingecko.svg'),
          classForHover: 'hovered-coin-gecko'
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
.token-services-data {
  padding: toRem(20px) 0;

  @include bp(m) {
    padding: toRem(40px) 0;
  }

  &__numbers {
    display: flex;
    flex-direction: column;
    gap: toRem(16px);

    @include bp(l) {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: toEm(24px);
    }
  }

  &__number-item {
    gap: toRem(16px);
    padding: toRem(20px);
    border-radius: toRem(20px);
    box-shadow: 0px 1px 20px 0px #1618220f;
    transition-duration: 0.3s;

    display: grid;
    grid-template-columns: toRem(66px) 1fr;
    align-items: center;

    img {
      // width: toRem(90px);
      // height: toRem(90px);
      width: toRem(66px);
      height: toRem(66px);
    }

    @include bp(m) {
      display: grid;
      grid-template-columns: toRem(140px) 1fr;
      gap: toRem(24px);
      padding: toRem(24px);
      min-height: toRem(188px);

      img {
        width: toRem(140px);
        height: toRem(140px);
      }
    }
  }

  &__number-item-rate {
    // background-color: color('transp-03');
    // border-radius: toRem(200px);
    // padding: toRem(4px) toRem(24px);
    // max-width: fit-content;
    display: flex;
    flex-direction: row;
    gap: toRem(12px);
    align-items: center;
  }

  &__number-item-data {
    display: flex;
    flex-direction: column;
    // align-items: center;
    gap: toRem(12px);

    @include bp(m) {
      justify-content: center;
      align-items: unset;
    }
  }

  &__stat-item-soon {
    // grid-area: soon;
    align-self: flex-start;
    padding: toRem(4px) toRem(8px);
    border-radius: toRem(20px);
    max-width: fit-content;

    @include bp(0px, m) {
      margin-left: auto;
    }
  }

  &__hovered-cmc {
    &:hover {
      background: color('color-10');
    }
  }
}
</style>
